import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import ChevronThinRightIcon from "@/icons/ChevronThinRightIcon";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import uiTypes from "@/view/constants/uiTypes";
import useUserContentUIContext from "@/view/utils/useUserContentUIContext";
import {
  buttonCss,
  iconCss,
  premiumLabelCss,
  rootCss,
} from "./ArticleActivityPickerOption.style";

const propTypes = {
  ariaProps: PropTypes.object,
  children: PropTypes.node,
  isAuthorizedChallengesPageUser: PropTypes.bool,
  eventProperties: PropTypes.object,
  isPremiumOption: PropTypes.bool,
  onClick: PropTypes.func,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const ArticleActivityPickerOption = ({
  ariaProps,
  children,
  eventProperties,
  isPremiumOption,
  isAuthorizedChallengesPageUser = false,
  onClick,
}) => {
  const { data: user } = useUser();
  const { isStudent } = getUserProperties(user);
  const { uiType } = useUserContentUIContext();
  const liteUserPremiumContent = uiType === uiTypes.LITE_USER_PREMIUM_CONTENT;
  const liteUserLiteContent = uiType === uiTypes.LITE;

  const PickerOptionIcon = () => {
    if (
      (!isStudent && liteUserPremiumContent) ||
      (liteUserLiteContent && isPremiumOption)
    ) {
      return (
        <span css={premiumLabelCss({ isAuthorizedChallengesPageUser })}>
          PREMIUM
        </span>
      );
    } else {
      return (
        <span css={iconCss} data-testid="icon">
          <ChevronThinRightIcon />
        </span>
      );
    }
  };

  return (
    <li css={rootCss}>
      <ButtonWithTrackEvent
        ariaProps={{ ...ariaProps }}
        disabled={
          liteUserPremiumContent || (liteUserLiteContent && isPremiumOption)
        }
        __cssFor={{
          root: buttonCss(
            liteUserPremiumContent,
            isAuthorizedChallengesPageUser,
          ),
        }}
        flavor={Button.flavors.incognito}
        onClick={onClick}
        {...eventProperties}
      >
        {children}
        <PickerOptionIcon>{children}</PickerOptionIcon>
      </ButtonWithTrackEvent>
    </li>
  );
};

ArticleActivityPickerOption.propTypes = propTypes;

export default ArticleActivityPickerOption;
